import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { LanguageModule } from '@language';
import {
    ShActionItemComponent,
    ShDynamicDialogModule,
    ShFormGroupComponent,
    ShFormMultiSelectModule,
    ShFormTextInputComponent,
    ShGenericOverviewContainerComponent,
    ShIconModule
} from '@stylehaven/components';
import { WebserviceListComponent } from './components/webservice-list/webservice-list.component';
import { WebserviceSearchDialogComponent } from './components/webservice-search-dialog/webservice-search-dialog.component';
import { WebserviceSearchComponent } from './components/webservice-search/webservice-search.component';
import { FormWebserviceComplexBaseComponent } from './containers/form-webservice/base-complex/form-webservice-base-complex.component';
import { FormWebserviceBaseComponent } from './containers/form-webservice/base-simple/form-webservice-base.component';
import { FormWebserviceComponent } from './containers/form-webservice/main/form-webservice.component';
import { WebserviceAdvancedSearchContainerComponent } from './containers/webservice-advanced-search/webservice-advanced-search-container.component';

@NgModule({
    declarations: [
        WebserviceSearchComponent,
        WebserviceAdvancedSearchContainerComponent,
        WebserviceSearchDialogComponent,
        WebserviceListComponent,
        FormWebserviceComponent,
        FormWebserviceBaseComponent,
        FormWebserviceComplexBaseComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ShActionItemComponent,
        ShIconModule,
        ShFormMultiSelectModule,
        LanguageModule,
        ShDynamicDialogModule,
        ShGenericOverviewContainerComponent,
        ShFormTextInputComponent,
        ShFormGroupComponent
    ],
    exports: [FormWebserviceComponent, FormWebserviceBaseComponent, FormWebserviceComplexBaseComponent]
})
export class ExternalWebserviceModule {}

export { FormWebserviceComplexBaseComponent } from './containers/form-webservice/base-complex/form-webservice-base-complex.component';
export { FormWebserviceBaseComponent } from './containers/form-webservice/base-simple/form-webservice-base.component';
export { FormWebserviceComponent } from './containers/form-webservice/main/form-webservice.component';
